import type { ConsentOptions } from '#nuxt-scripts/registry/google-analytics'

export const DEFAULT_PRIVACY_PREFS: PrivacyPrefs = {
  analytics: false,
  marketing: false,
  functionality: true,
}

export const DEFAULT_GA_CONSENT_STATE: GAConsentState = {
  ad_user_data: false,
  ad_personalization: false,
  ad_storage: false,
  analytics_storage: false,
}
export const DEFAULT_GA_CONSENT_OPTIONS: ConsentOptions = {
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  ad_storage: 'denied',
  analytics_storage: 'denied',
}

export const DEFAULT_HS_CONSENT_STATE: HSConsentState = {
  analytics: false,
  advertisement: false,
  functionality: true,
}
